import angular from 'angular';
import defaultComponent from './default.component';

let defaultModule = angular.module('default', [])
.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";

  // $urlRouterProvider.otherwise('/');

  $stateProvider
    .state('default', {
      url: '/',
      component: 'default'
    });
})
.component('default', defaultComponent)

.name;

export default defaultModule;



// WEBPACK FOOTER //
// ./client/app/pages/default/default.js